// extracted by mini-css-extract-plugin
export default {"wrap":"private_wrap__ugXCM"};